export default "__VITE_ASSET__TdT7YFNq__"